import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from 'react';
import httpService from "../../../services/http.service";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import {useFormik} from "formik";
import * as Yup from 'yup';
import AppInput from "../../Shared/AppInput";
import {Form} from "reactstrap";
import useAlert from "../../../hooks/useAlert";
import AppAlert from "../../Shared/AppAlert";
import {connect} from "react-redux";
import AppCheckbox from "../../Shared/AppCheckbox";
import {extractResponseValidationErrors, SECTION_TYPE_DIRECTION, SECTION_TYPE_DEPARTMENT, SECTION_TYPE_SERVICE, SECTION_TYPE_EMPLOYER} from "../../../utils/index";
import AppSelect from "../../Shared/AppSelect";
import {Link, Redirect} from "react-router-dom";
import ActionsDropdown from "./ActionsDropdown";
import {canManage, deleteAccount, forceLogout, resetPassword, toggleAccount} from "./actions";

const ModerateurList = ({authUser, ...props}) => {
    const { t } = useTranslation();

    const initialValues = {
        nom: '',
        prenom: '',
        email: '',
        password: '',
        section_type: '',
        section_name: '',
        password_confirmation: '',
        isAdmin: false,
        role_id: '',
        editMode: false,
    };

    const [fetching, setFetching] = useState(true);
    const [submitting, setSubmission] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [roles, setRoles] = useState([]);
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [roleFilter, setRoleFilter] = useState('');
    const [data, setData] = useState(initialValues);
    const [modal, setModal] = useState(false);
    const [alert, setAlert, onClose] = useAlert();
    const [ddls, setDdls] = useState({
        section_types: [],
        section_names: []
    });

    const fetchAdmins = async (cb = () => null) => {
        const {data: response} = await httpService.get(`/moderateurs`);
        // setAdmins(response?.data);
        cb(response?.data);
        return response?.data;
    }

    const fetchSectionTypes = async (cb = () => null) => {
        const {data: response} = await httpService.get(`/hr/section_types`);
        cb(response?.data);
        return response?.data
    }

    const fetchSections = async (sectionType = SECTION_TYPE_DIRECTION, cb = () => null) => {

        let url = '';

        switch (sectionType) {

            case SECTION_TYPE_DIRECTION:
                url = '/hr/directions';
                break;
            case SECTION_TYPE_DEPARTMENT:
                url = '/hr/departments';
                break;
            case SECTION_TYPE_SERVICE:
                url = '/hr/services';
                break;
            case SECTION_TYPE_EMPLOYER:
                url = '/hr/employers';
                break;

        }

        const {data: response} = await httpService.get(url);
        cb(response?.data);
        return response?.data
    }

    const onSectionTypeChange = (e) => {
        const value = e.target.value;
        formik.setFieldValue('section_type', value, true);
        formik.setFieldTouched('section_type', true);


        formik.setFieldValue('section_name', '', true);
        formik.setFieldTouched('section_name', true);
        setDdls(ddls => ({
            ...ddls,
            section_names: []
        }));

        if(!value) return

        (async () => {
           const sections = await fetchSections(value);
           setDdls(ddls => ({
               ...ddls,
               section_names: sections
           }));
        })();

    }

    const onSubmit = async (values) => {
        setSubmission(true);
        setAlert(null);

        const link = `${window.location.protocol}//${window.location.hostname}`

        const formData = {
            ...values,
            link
        };

        try {
            if(values.editMode) {
                const {data: response} = await httpService.put(`/moderateurs/${values.id}`, formData);

                const newArr = admins.map(admin => {
                    if(admin.id === values.id) {
                        return {
                            ...response.data
                        }
                    }

                    return admin;
                });

                setAdmins(newArr);
            }
            else {
                const {data: response} = await httpService.post('/moderateurs', formData);

                setAdmins((state) => [
                    ...admins,
                    response.data
                ]);
            }

            onCancel();

        } catch ({response}) {
            const {data, status} = response || {};

            if(status === 403) {
                setAlert({
                    type: 'danger',
                    message: data?.message || t("Action non autorisée")
                })
            }
            else if(response && status === 422) {
                setAlert({
                    type: 'danger',
                    message: extractResponseValidationErrors(data)[0]
                })
            }
            else if(response && status === 500) {
                setAlert({
                    type: 'danger',
                    message: t("Erreur de traitement, veuillez contacter les administrateurs")
                })
            }
        } finally {
            setSubmission(false);
        }
    }

    const onEditAdmin = (admin) => {

        (async () => {
            if(admin?.section_type) {
                const sections = await fetchSections(admin.section_type);
                setDdls(state => ({
                    ...state,
                    section_names: sections
                }))
            }
        })()

        setData({
            ...admin,
            editMode: true
        });
        setModal(true);
    }

    const replaceAdmin = (updated) => {
        if (updated) setAdmins(state => state.map(obj => obj.id === updated.id ? updated : obj));
    }

    const onAction = async (admin, action) => {
        switch (action) {
            case 'edit':
                return onEditAdmin(admin);
            case 'toggle':
                return replaceAdmin(await toggleAccount(admin));
            case 'reset-password':
                return replaceAdmin(await resetPassword(admin));
            case 'logout':
                return replaceAdmin(await forceLogout(admin));
            case 'delete':
                if (await deleteAccount(admin)) setAdmins(state => state.filter(obj => obj.id !== admin.id));
                return;
            default:
        }
    }

    const onAddAdmin = () => {
        setData(initialValues);
        setModal(true);
    }

    const onCancel = () => {
        formik.resetForm(initialValues);
        setData(initialValues);
        setAlert(null);
        setModal(false);
    }

    const resetForm = () => {}

    useEffect(() => {
        (async () => {
           const admins = await fetchAdmins();
           const section_types = await fetchSectionTypes();
            try {
                const {data: rolesResponse} = await httpService.get('/roles');
                setRoles(rolesResponse?.data || []);
            } catch (e) {
                setRoles([]);
            }
            setAdmins(admins)
            setDdls(state => ({
                ...state,
                section_types
            }));

            setFetching(false);

            // Bouton « Modifier » de la fiche : /moderateurs?edit=<email> ouvre directement le formulaire.
            const editEmail = new URLSearchParams(window.location.search).get('edit');
            const toEdit = editEmail && (admins || []).find(admin => admin.email === editEmail);
            if (toEdit && canManage(authUser, toEdit)) onEditAdmin(toEdit);
        })()
    }, []);

    useEffect(() => {

        formik.setValues({
            ...initialValues,
            ...data,
        });

    }, [data]);

    const editMode = !!data?.id;

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            nom: Yup.string().ensure().required(t("Champ obligatoire")),
            prenom: Yup.string().ensure().required(t("Champ obligatoire")),
            email: Yup.string().email(i18n.t("Format email invalide")).ensure().required(t("Champ obligatoire")),
            password: Yup.string().ensure().nullable().test(
                'min-if-filled',
                t("Minimun 6 carateres"),
                (value) => !value || value.length >= 6
            ),
            password_confirmation: Yup.string().ensure().nullable().when('password', {
                is: (password) => !!password,
                then: Yup.string().ensure().oneOf([
                    Yup.ref('password')
                ], i18n.t("Le mot de passe ne correspond pas")).required(t("Champ obligatoire"))
            }),
            section_type: Yup.string().ensure().nullable(),
            section_name: Yup.string().ensure().when(
                [],
                {
                    is: () => formik.values.section_type,
                    then: Yup.string().ensure().required(t("Champ obligatoire")),
                    otherwise: Yup.string().ensure().nullable()
                }
            ),
        }),
        onSubmit
    });

    if(!authUser.isRoot) {
        return <Redirect to="/unauthorize" />
    }

    const needle = search.trim().toLowerCase();
    const visibleAdmins = admins.filter(admin => {
        if (needle && !`${admin.nom || ''} ${admin.prenom || ''} ${admin.email || ''}`.toLowerCase().includes(needle)) return false;
        if (statusFilter === 'active' && !admin.actif) return false;
        if (statusFilter === 'inactive' && admin.actif) return false;
        if (roleFilter === 'root' && !admin.isRoot) return false;
        if (roleFilter && roleFilter !== 'root' && String(admin.role_id || '') !== roleFilter) return false;
        return true;
    });

    return (
        <div className="container-fluid">
            <AppBreadcrumb title={t("Modérateurs")}>
                <div className="col-md-6 col-sm-12 text-right">
                    <button className="btn btn-sm btn-primary font-weight-bold" onClick={onAddAdmin}>
                        <i className="fa fa-plus"></i>{' '}
                        <span>{t("Nouveau modérateur")}</span>
                    </button>
                </div>
            </AppBreadcrumb>

            {!fetching && (
                <div className="row mb-3">
                    <div className="col-md-5">
                        <input
                            className="form-control"
                            placeholder={t("Rechercher par nom ou adresse e-mail")}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                    <div className="col-md-3">
                        <select className="form-control" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                            <option value="">{t("Tous les statuts")}</option>
                            <option value="active">{t("Actifs")}</option>
                            <option value="inactive">{t("Inactifs")}</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <select className="form-control" value={roleFilter} onChange={(e) => setRoleFilter(e.target.value)}>
                            <option value="">{t("Tous les rôles")}</option>
                            <option value="root">{t("Super administrateur")}</option>
                            {roles.map(role => (
                                <option key={role.id} value={String(role.id)}>{role.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            )}

            {fetching ? <FecthingSpinner /> : (
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="table-responsive">
                            <table className="table table-hover table-custom spacing5">
                                <tbody>
                                {visibleAdmins.map(admin => (
                                    <tr key={admin.id}>
                                        <td className="w60">
                                            <img src={admin.photo || MyOpinionLogo} data-toggle="tooltip" data-placement="top" title="" alt="Avatar" className="w35 rounded" data-original-title="Avatar Name" />
                                        </td>
                                        <td>
                                            <Link to={`/moderateurs/${encodeURIComponent(admin.email)}`} className="font-weight-bold">{admin.nom} {admin.prenom}</Link>
                                        </td>
                                        <td>
                                            <span>{admin.email}</span>
                                        </td>
                                        <td>
                                            {admin?.isRoot ? (
                                                <span className="badge badge-danger">{t("Super administrateur")}</span>
                                            ) : (
                                                <>
                                                    {admin.isAdmin ? (
                                                        <span className="badge badge-warning">{t("Adminsitrateur")}</span>
                                                    ) : (
                                                        <span className="badge badge-default">{t("Modérateur")}</span>
                                                    )}
                                                    {admin.role_name && (
                                                        <span className="badge badge-info ml-1">{admin.role_name}</span>
                                                    )}
                                                </>
                                            )}

                                        </td>
                                        <td>
                                            {admin.actif ? (
                                                <span className="badge badge-success">{t("Actif")}</span>
                                            ) : (
                                                <span className="badge badge-danger">{t("Inactif")}</span>
                                            )}
                                        </td>
                                        <td>
                                            <span className="text-muted small">
                                                {admin.last_login_at ? new Date(admin.last_login_at).toLocaleString(i18n.language === 'en' ? 'en-GB' : 'fr-FR') : t("Jamais connecté")}
                                            </span>
                                            {admin.tokens_count > 0 && (
                                                <span className="badge badge-default ml-1">{t("{{n}} session(s)", {n: admin.tokens_count})}</span>
                                            )}
                                        </td>
                                        <td className="text-right">
                                            <ActionsDropdown
                                                admin={admin}
                                                manageable={canManage(authUser, admin)}
                                                onAction={(action) => onAction(admin, action)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                {visibleAdmins.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="text-center text-muted">{t("Aucun compte ne correspond à la recherche.")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            <div className={`modal fade ${modal ? 'd-block show' : ''}`} id="exampleModal" style={{overflowY: 'auto'}} onClick={() => null}>
                <div className="modal-dialog modal-lg" role="document">
                    <Form onSubmit={formik.handleSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">{editMode ? 'Édition' : 'Nouvel administrateur'}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
                                <div className="row">
                                    <div className="col-md-6">
                                        <AppInput
                                            name="nom"
                                            label={t("Nom")}
                                            value={formik.values.nom}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.errors.nom}
                                            touched={formik.touched.nom}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <AppInput
                                            name="prenom"
                                            label={t("Prénom")}
                                            value={formik.values.prenom}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.errors.prenom}
                                            touched={formik.touched.prenom}
                                            required
                                        />
                                    </div>
                                </div>
                                <AppInput
                                    name="email"
                                    label={t("Adresse email")}
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.email}
                                    touched={formik.touched.email}
                                    required
                                />
                                <div className="form-group">
                                    <AppCheckbox
                                        name="isAdmin"
                                        label={t("Administrateur ?")}
                                        onChange={(e) => formik.setFieldValue('isAdmin', e.target.checked)}
                                        checked={formik.values.isAdmin}
                                    />
                                </div>
                                <AppSelect
                                    name="role_id"
                                    label={t("Rôle (permissions)")}
                                    value={formik.values.role_id ?? ''}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">{t("Rôle par défaut (selon le type de compte)")}</option>
                                    {roles.map(role => (
                                        <option key={role.id} value={role.id}>{role.name}</option>
                                    ))}
                                </AppSelect>
                                {(process.env.REACT_APP_SOCIAL_HUB && !formik.values.isAdmin) && (
                                    <div className="row">
                                        <div className="col-md-6">
                                            <AppSelect
                                                name="section_type"
                                                label={t("Type de section")}
                                                value={formik.values.section_type}
                                                error={formik.errors.section_type}
                                                touched={formik.touched.section_type}
                                                onChange={onSectionTypeChange}
                                                onBlur={formik.handleBlur}
                                            >
                                                {ddls.section_types.map(section => (
                                                    <option key={section?.value} value={section?.value}>{section?.label_fr}</option>
                                                ))}
                                            </AppSelect>
                                        </div>
                                        <div className="col-md-6">
                                            <AppSelect
                                                name="section_name"
                                                label={t("Section")}
                                                value={formik.values.section_name}
                                                error={formik.errors.section_name}
                                                touched={formik.touched.section_name}
                                                required={formik.values.section_type}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            >
                                                {ddls.section_names.map(section => (
                                                    <option key={section?.value} value={section?.value}>{section?.value}</option>
                                                ))}
                                            </AppSelect>
                                        </div>
                                    </div>
                                )}
                                <hr/>
                                <AppInput
                                    type="password"
                                    name="password"
                                    label={t("Nouveau mot de passe")}
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.password}
                                    touched={formik.touched.password}
                                />
                                <p className="text-muted small">
                                    {editMode
                                        ? t("Laisser vide pour conserver le mot de passe actuel.")
                                        : t("Laisser vide : un mot de passe temporaire est généré et envoyé par e-mail.")}
                                </p>
                                <AppInput
                                    type="password"
                                    name="password_confirmation"
                                    label={t("Confirmation du mot de passe")}
                                    value={formik.values.password_confirmation}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.password_confirmation}
                                    touched={formik.touched.password_confirmation}
                                    required={!!formik.values.password}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className={`btn btn-round btn-danger font-weight-bold`} disabled={submitting} data-dismiss="modal" onClick={onCancel}>
                                    <span className="fa fa-times"></span>{' '}Annuler
                                </button>
                                <button type="submit" className={`btn btn-round btn-success font-weight-bold`} disabled={submitting}>
                                    <span className="fa fa-save"></span>{' '}{submitting ? 'Encour...' : 'Enregistrer'}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authUser: state.auth.user
})

const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(ModerateurList);